import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CheckBoxOutlineBlankIcon(props: FixMe) {
  return <CheckBoxOutlineBlank {...props} />;
}

export default CheckBoxOutlineBlankIcon;
